import { ProvidentFundsState } from "@reducers/types/HRM/provident-funds-state";

import { ProvidentFundsActions } from "@actions/HRM/providentFunds/provident-funds-actions";
import { GET_PROVIDENT_FUNDS } from "@actions/HRM/providentFunds/types";

import {
  getFailedState,
  getRequestingState,
  getSuccessState,
} from "@utils/store";

const initialState: ProvidentFundsState = {
  request: false,
};

const providentFundsReducer = (
  state = initialState,
  action: ProvidentFundsActions
): ProvidentFundsState => {
  switch (action.type) {
    case GET_PROVIDENT_FUNDS.GET_PROVIDENT_FUNDS_REQUEST: {
      return {
        ...getRequestingState(),
      };
    }
    case GET_PROVIDENT_FUNDS.GET_PROVIDENT_FUNDS_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({ data: payload.data }),
      };
    }
    case GET_PROVIDENT_FUNDS.GET_PROVIDENT_FUNDS_FAILED: {
      return {
        ...getFailedState(),
      };
    }
    default:
      return state;
  }
};

export default providentFundsReducer;
